const Config = require("../config");

const Calc   = require("../utillity/calculate");
const Rwd    = require("../utillity/responsive");
const Utill  = require("../utillity/utill");

const Header = require("../dom/header");
const Footer = require("../dom/footer");
const Pagetop= require('../dom/pagetop');

const Home   = require('./home');
const Map    = require('./map');


let flug = true;
let item = '[data-section]';
let $item = $(item);

/*
	scrollify init
*/
module.exports.Init = function() {
	Utill.SetScroll0();
	if( !$('.body--home').length ) return;
	if( Utill.IsOriginAnime() ) return;

	let count = $item.length;
	let _t = this;

	_t.SetSize();

	// set footer
	let val = 'bottom ' + Config.HOME_SCR_TIME + 'ms cubic-bezier(0.19, 1, 0.22, 1) 0s';
	$('#gFooter').css({
		'opacity': 1,
		'transition': val,
	});

	$item.css({'opacity': 1});

	$.scrollify({
		section : item,
		sectionName : "section-name",
		interstitialSection : "",
		easing: "easeOutExpo",
		scrollSpeed: Config.HOME_SCR_TIME,
		offset : 0,
		scrollbars: true,
		standardScrollElements: ".js_scrfy_standard",
		setHeights: false,
		overflowScroll: true,
		updateHash: false,
		touchScroll:true,
		before:function(index, sections) {
			// set current
			$(item).removeClass('is_active');
			sections[index].addClass('is_active');

			// footer position
			let last = index === sections.length- 1;
			let order= last? 'visible': 'unvisible';

			Footer.ToggleVisible( order );

			Header.ControleLogo(index);
		},
		after:function(index, sections) {

			// Header.ControleLogo(index);

			_t.SkinOrder(index);

			_t.SetPagination(index);


		},
		afterResize:function() {
			$.scrollify.update();
			_t.SetSize();
		},
		afterRender:function() {

			_t.InitPagination();

			// panel set first
			setTimeout(function() {
				$.scrollify.move(0);
			});
		}
	});
	//_t.Controll(-1);	// ↑
};

module.exports.SetPagination  = function(index) {
	$('.home-pagination li').removeClass('is_active').eq(index).addClass('is_active');
};

module.exports.SkinOrder  = function(index) {

	Pagetop.ControllVisible( index );

	switch(index) {
		case 0:  Header.CtrlSkin( 'w' ); Pagetop.SetSkin('scroll',  'white', 'white'); break;
		case 1:  Header.CtrlSkin( 'b' ); Pagetop.SetSkin('scroll',  'black', 'blue');  break;
		case 2:  Header.CtrlSkin( 'w' ); Pagetop.SetSkin('scroll',  'white', 'white'); break;
		case 3:  Header.CtrlSkin( 'b' ); Pagetop.SetSkin('scroll',  'black', 'blue');  break;
		case 4:  Header.CtrlSkin( 'w' ); Pagetop.SetSkin('scroll',  'white', 'white'); break;
		case 5:  Header.CtrlSkin( 'w' ); Pagetop.SetSkin('scroll',  'white', 'white'); break;
		case 6:  Header.CtrlSkin( 'b' ); Pagetop.SetSkin('pagetop', 'black', 'blue');  break;
		default: Header.CtrlSkin( 'w' ); Pagetop.SetSkin('scroll',  'white', 'blue');  break;
	}
};

module.exports.SetSize  = function() {

	$('[data-section]').each(function(index, el) {
		$(el).css({
			'width': $(window).innerWidth(),
			'height': $(window).innerHeight(),
		})
	});

	if( Utill.IsOriginAnime() ) {
		$('[data-section_bg] > div').each(function(index, el) {
			$(el).css({
				'width': $(window).innerWidth(),
				'height': $(window).innerHeight(),
			})
		});
	}
};

module.exports.MoveNext  = function() { $.scrollify.next(); };
module.exports.Move  = function(num) {$.scrollify.move(num);};

module.exports.InitPagination = function(){
	if ( !$('body').hasClass('body--home') ) return;

	let count = $('[data-section]').length;
	let li_c = $('.home-pagination li').length;

	if( li_c < count ) {
		// create
		for (var i = 0; i < count - 1; i++) {
			$('.home-pagination li:first-child').clone().appendTo($('.home-pagination'));
		};
	}

	// init
	$('.home-pagination li:first-child').addClass('is_active');

	let h = $('.home-pagination').innerHeight();
	$('.home-pagination').css({
		'margin-top': h / -2 + 'px',
	});
};

module.exports.Pager = function(el){
	if ( !$('body').hasClass('body--home') ) return;

	let i = el.closest('li').index();
	$.scrollify.move( i );
};

module.exports.ToggleEnable = function(){
	if( $('body').hasClass('body--home') ) {
		$.scrollify.enable();
	}else {
		$.scrollify.disable();
	}
};

// ここから手書き
module.exports.slugInit = function(){
	$('[data-section]').each(function(index, el) {
		$(el).attr('data-num', index);

		if( index === 0 ) {
			$(el).attr('data-current', true);
		}
	});
};

module.exports.ChangeSec = function(d, nextIndex){
	if( !Utill.IsOriginAnime() ) return;
	let _t = this;
	if(!flug) return;
	flug = false;

	// get inf
	let $item = $('[data-section]');
	let c = $item.length;
	let cI = Number( $('[data-current="true"]').attr('data-num') );
	
	// outer range
	if( cI+d < 0 || c-1 < cI+d ) {
		flug = true;
		return;
	}

	let nI = nextIndex===undefined? cI + d: nextIndex;

	_t.SecFadeOut(cI, d, nI);
	Home.beforeSectionChanger(d);

	//console.log('currentIndex: ' + cI, 'direction: ' + d, 'nextIndex: ' + nI);

	// set inf
	$item.attr('data-current', false);
	$item.eq(nI).attr('data-current', true);

	// logo
	Header.ControleLogo(nI);

	// ex
	/*setTimeout(function() {
		_t.SecFadeIn(nI, d);
	}, Config.HOME_SCR_TIME / 2);*/

	// 
	setTimeout(function() {
		flug = true;
	}, Config.HOME_SCR_TIME * 2);
}

module.exports.SecFadeInit  = function(){
	if( Utill.IsOriginAnime() ) {
		$('[data-sec_item]').css({'opacity': 0});
	}
};


let SecFadeInFLUG = true;	// 謎の2回の実行をキャンセル
module.exports.SecFadeIn  = function(sectionNum, d){
	if( !SecFadeInFLUG ) return;
	SecFadeInFLUG=false;
	setTimeout(function() { SecFadeInFLUG=true; }, 100);
	let _t = this;
	let $sec = $('[data-section]').eq(sectionNum);
	let $bg  = $('[data-section_bg]').children('div').eq(sectionNum);
	let item = $sec.find('[data-sec_item]');
	let c    = item.length;
	let time = 450;

	// 子要素のタイミング
	let item_duration   = sectionNum===0&&d===1? 750: 600;
	let item_delay      = sectionNum===0&&d===1? 600: 330;
	let item_stag_delay = sectionNum===0&&d===1? 900: 360;

	_t.AnimeBg(sectionNum, time);

	setTimeout(elAnim, time);

	function elAnim() {
		var tl = new TimelineMax();
		tl
			.set(item, {
				opacity: 0,
				y: 15 * d,
			}).to($sec, 0.1, {
				opacity: 1
			}).staggerTo(
				item,
				Calc.ToSecond( item_duration ),
				{
					delay: Calc.ToSecond( item_delay ),
					opacity: 1,
					y: 0,
					ease: Power3.easeOut,
					onCompleteParams:["{self}"],
					onComplete: function(a) {
						if( a._next === null ) {
							csr();
						}
					},
				},
				Calc.ToSecond( item_stag_delay ),
			);
		function csr() {
			// console.log('最後の子要素fadeIn')
		}
	};

	let order= sectionNum===$('[data-section]').length-1? 'visible': 'unvisible';
	Footer.ToggleVisible( order );
	_t.SkinOrder(sectionNum);
	_t.SetPagination(sectionNum);
};
module.exports.SecFadeOut = function(sectionNum, d, nI){
	let _t = this;
	let $sec = $('[data-section]').eq(sectionNum);
	let $bg  = $('[data-section_bg]').children('div').eq(sectionNum);
	let item = $sec.find('[data-sec_item]');
	let tl = new TimelineMax();
	let _ni = nI;
	let _d = d;
	tl
		.set($bg.siblings('div'), {opacity: 0})
		.staggerTo(
			item,
			Calc.ToSecond( Config.HOME_SCR_TIME / 4 ),
			{
				opacity: 0,
				y: -15 * d,
				delay: 0.2
			},
			Calc.ToSecond( 150 ),
		).to($sec, Calc.ToSecond( Config.HOME_SCR_TIME / 3 ), {
			opacity: 0,
			delay: 0.05,
			//onComplete: move,
		}).to($bg, Calc.ToSecond( 300 ), {
			opacity: 0,
			onComplete: move,
		});
	function move() {
		_t.MoveWrapper(_ni, _d);
		Home.AfterSectionChanger(_d)
	}
};

module.exports.MoveWrapper = function(nextNum, direction){
	let target  = $('[data-section]').innerHeight() * nextNum * -1;
	let _t = this;
	
	TweenMax.to($('[data-section_wrap]'), Calc.ToSecond( 10 ), {
		y: target,
		// onComplete: _t.SecFadeIn(nextNum, direction),
		onComplete: MoveBg,
	});

	function MoveBg() {
		TweenMax.to($('[data-section_bg]'), Calc.ToSecond( 0 ), {
			y: target,
			onComplete: _t.SecFadeIn(nextNum, direction),
		});	
	}
};

module.exports.AnimeBg = function(num, time){
	let $block = $('[data-section_bg]').children('div').eq(num);
	let tl = new TimelineMax();

	switch(num) {
		case 0: func00(); break;
		case 1: func01(); break;
		case 5: func05(); break;
		default: Default(); break;
	}

	function func00() {
		// console.log('func00');
		tl.to($block, Calc.ToSecond( time ), {
			opacity: 1,
			onComplete: Home.AfterChangeDeco,
		});
		// console.log('test')
	}
	function func01() {
		// console.log('func01');

		tl.to($block, Calc.ToSecond( time ), {
			opacity: 1,
			onComplete: Map.Animate,
		});	
	}
	function func05() {
		// console.log('func05');
		tl.to($block, Calc.ToSecond( time ), {
			opacity: 1,
		});	
	}
	function func06() {
		// console.log('func06');
	}
	function Default() {
		tl.to($block, Calc.ToSecond( time ), {
			opacity: 1,
		});	
	}

}


// WEBPACK FOOTER //
// ./html/_src/js_wb/animation/section_scroll.js